import React from "react";

const LogoSolar = ({
  width = "auto",
  fillIntelbras = "#FFFFFF",
}: {
  width?: string;
  fillIntelbras?: string;
}) => {
  return (
    <svg
      version="1.1"
      id="Camada_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 636.35 130.47"
      xmlSpace="preserve"
      width={width}
    >
      <style type="text/css">
        {`
          .st0 {
            opacity: 0;
            fill-rule: evenodd;
            clip-rule: evenodd;
            fill: #FFFFFF;
          }
        `}
      </style>
      <rect x="-75.24" y="-56.32" className="st0" width="784.83" height="255.12"/>
      <g>
        <path fill={fillIntelbras} className="st1" d="M504.55,33.94c-25.18,0-45.59,20.41-45.59,45.59c0,25.17,20.41,45.59,45.59,45.59c8.31,0,16.1-2.23,22.8-6.11
          v6.12h22.79V79.53C550.14,54.35,529.73,33.94,504.55,33.94z M527.34,79.53v0.23c-0.12,12.48-10.28,22.57-22.79,22.57
          c-12.59,0-22.8-10.2-22.8-22.79c0-12.59,10.21-22.8,22.8-22.8C517.14,56.73,527.35,66.94,527.34,79.53L527.34,79.53z"/>
        <path fill={fillIntelbras} className="st1" d="M176.48,100.6c-2.31,1.1-4.88,1.73-7.61,1.73c-9.79,0-17.73-7.94-17.73-17.73h0l0-27.86l17.25,0
          c0,0,2.86-10.05,2.86-22.79l-20.11,0V7.27c-12.75,0-22.8,3.37-22.8,3.37s0.01,13.7,0,23.3h0v50.61c0,0.02,0,0.03,0,0.05
          c0,22.38,18.14,40.52,40.52,40.52c7.66,0,14.82-2.13,20.93-5.83C184.11,114.13,179.53,107.77,176.48,100.6z"/>
        <path fill={fillIntelbras} className="st1" d="M468.76,39.76c-6.11-3.69-13.27-5.83-20.93-5.83c-22.38,0-40.52,18.14-40.52,40.52c0,0.02,0,0.03,0,0.05v50.61
          h22.79l0-50.66h0c0-9.79,7.94-17.73,17.72-17.73c2.73,0,5.31,0.63,7.62,1.73C458.5,51.28,463.07,44.92,468.76,39.76z"/>
        <path fill={fillIntelbras} className="st1" d="M19.6,5.35c-6.88,0-12.46,5.58-12.46,12.46c0,6.89,5.58,12.47,12.46,12.47c6.88,0,12.46-5.58,12.46-12.47
          C32.06,10.93,26.48,5.35,19.6,5.35z"/>
        <path fill={fillIntelbras} className="st1" d="M80.12,33.94c-22.38,0-40.52,18.14-40.52,40.52c0,0.01,0,0.03,0,0.05v50.61h22.79V74.46l0,0
          c0-9.79,7.94-17.73,17.73-17.73c9.79,0,17.73,7.94,17.73,17.73v50.66h22.79V74.46C120.64,52.08,102.5,33.94,80.12,33.94z"/>
        <path fill={fillIntelbras} className="st1" d="M8.2,125.12H31V33.94c-12.75,0-22.79,3.37-22.79,3.37V125.12z"/>
        <path fill={fillIntelbras} className="st1" d="M276.78,125.11h22.8V7.27c-12.47,0-22.37,3.23-22.78,3.36L276.78,125.11z"/>
        <path fill={fillIntelbras} className="st1" d="M354.37,33.94c-8.3,0-16.08,2.23-22.79,6.11l-0.01-32.78c-12.49,0-22.4,3.24-22.78,3.36
          c0,0-0.02,68.84-0.02,68.89c0,25.17,20.41,45.59,45.59,45.59c25.18,0,45.59-20.41,45.59-45.59
          C399.97,54.35,379.56,33.94,354.37,33.94z M354.37,102.32c-12.59,0-22.8-10.21-22.8-22.79h0.01v-0.17
          c0.09-12.51,10.26-22.63,22.79-22.63c12.59,0,22.8,10.21,22.8,22.8C377.17,92.11,366.97,102.32,354.37,102.32z"/>
        <path fill={fillIntelbras} className="st1" d="M269.86,90.32c-11.76-4.67-22.04-5.01-22.04-5.01c-2.85,10.98-13.5,18.36-25.03,16.84
          c-2.59-0.34-5.02-1.11-7.23-2.22l51.56-39.56c-6.36-13.67-19.35-23.9-35.4-26.01c-24.96-3.29-47.85,14.28-51.13,39.24
          c-3.29,24.96,14.28,47.85,39.23,51.13C242.87,127.77,264.17,112.27,269.86,90.32L269.86,90.32z M203.15,76.57
          c1.64-12.49,13.1-21.28,25.59-19.64c2.59,0.34,5.02,1.11,7.23,2.22l-32.55,24.97C202.92,81.71,202.81,79.17,203.15,76.57z"/>
        <path fill={fillIntelbras} className="st1" d="M601.49,69.68l-15-0.01c-3.57,0-6.47-2.89-6.47-6.47c0-3.57,2.9-6.47,6.47-6.47h32.75
          c0.13-0.41,3.36-10.23,3.36-22.7c0,0-35.47,0-37.65,0c-15.31,0-27.72,12.41-27.72,27.72s12.41,27.73,27.72,27.73h15
          c3.57,0,6.47,2.9,6.47,6.47c0,3.57-2.9,6.47-6.47,6.47H562.8c-0.14,0.41-3.36,10.23-3.36,22.7c0,0,41.5,0,42.05,0
          c15.31,0,27.72-12.41,27.72-27.72C629.21,82.09,616.8,69.68,601.49,69.68z"/>
      </g>
    </svg>
  );
};

export { LogoSolar };
